<template>
  <v-card>
    <v-card-title style="height: 64px;">
      <span class="title pl-2 py-1">关联模板</span>
    </v-card-title>
    <v-card-text>
      <v-form v-model="valid">
        <v-container>
          <v-layout row wrap>
            <v-flex xs12>
              <v-autocomplete
                label="选择模板"
                :items="items"
                item-text="name"
                item-value="id"
                v-model="item"
                :rules="$rules.required()"
                :loading="isLoading"
                :search-input.sync="search"
                hide-selected
                :placeholder="search? '没有可选项':'输入以搜索'"
                :no-data-text="typeof search === 'string' && search.trim()?'没有匹配选项':'输入以搜索'"
                :hide-no-data="isLoading || !search"
                return-object
                chips
                deletable-chips
              >
                <template slot="append-item">
                  <v-list-tile v-if="items.length >= maxItem">
                    <v-list-tile-title>
                      <span class="grey--text">仅显示前{{maxItem}}个结果</span>
                    </v-list-tile-title>
                  </v-list-tile>
                </template>
              </v-autocomplete>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn large color="grey" :loading="cancelLoading" flat @click="cancel">取消</v-btn>
      <v-btn large :disabled="!valid" color="primary" :loading="confirmLoading" flat @click="save">保存</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import debounce from 'lodash/debounce'

export default {
  name: 'LSelectTemplateDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    rawItem: {type: [Object, String]},
    type: {type: String, default: 'sms'}
  },
  data: () => ({
    maxItem: 50,
    valid: false,
    textLimit: 30,
    templates: [],
    isLoading: false,
    model: null,
    search: null,
    count: 0,
    activate: false,
    cancelLoading: false,
    confirmLoading: false,
    item: null,
  }),
  computed: {
    items () {
      return this.templates.map(t => {
        const text = t.name.length > this.textLimit
          ? t.text.slice(0, this.textLimit) + '...'
          : t.text

        return Object.assign({}, t, {text})
      })
    }
  },
  watch: {
    search (val) {
      if (!this.search) return
      // Items have already been loaded
      this.getTemplates()
    }
  },
  methods: {
    getTemplates: debounce(async function (id) {
      this.isLoading = true
      let searchParam = {
        'searchParam': {
          'name': {
            'keyword': this.search || '',
            'order': 'ASC'
          },
          'type': {
            'keyword': this.type,
            'order': 'ASC'
          },
        }
      }
      try {
        let res = await this.$store.dispatch('messageManagement/getTemplateList', {
          pagination: {page: 1, rowsPerPage: this.maxItem},
          searchParam: searchParam})
        if (res.data.status === 1) {
          this.count = res.data.data.numberOfElements
          this.templates = res.data.data.content
        }
      }
      catch (e) {
        this.$L.alert('error', {title: '获取模板时发生错误', message: e.message, raw: e})
      }

      this.isLoading = false
    }, 600),
    save () {
      // console.log(this.item)
      this.$emit('save', this.item)
      this.$emit('input', false)
    },
    cancel () {
      this.$emit('input', false)
      this.$emit('cancel')
    }
  },
  async created () {
    // console.log('in select template', this.rawItem)
    if (this.rawItem instanceof Object && this.rawItem.name && this.rawItem.id) {
      this.item = this.rawItem
      // console.log(this.item)
      this.templates = [this.item]
    }
    else if (typeof this.rawItem === 'string') {
      let searchParam = {
        'searchParam': {
          'type': {
            'keyword': this.type,
            'order': 'ASC'
          },
        }
      }
      // console.log('find', this.rawItem)
      this.isLoading = true
      try {
        let res = await this.$store.dispatch('messageManagement/getTemplateList', {
          pagination: {page: 1, rowsPerPage: this.maxItem},
          searchParam: searchParam})
        if (res.data.status === 1) {
          this.count = res.data.data.numberOfElements
          this.templates = res.data.data.content
          if (this.count === 1) {
            this.item = this.templates[0]
          }
        }
      }
      catch (e) {
        this.$L.alert('error', {title: '获取模板时发生错误', message: e.message, raw: e})
      }
      this.isLoading = false
    }
    else {
      this.getTemplates()
    }
  }
}
</script>

<style scoped>

</style>
